export const commonErrorMessage = "Số hợp đồng hoặc thông tin nhân thân không chính xác";
